import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase/app";

export default {
  name: "AddHocActivityDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isEdit: false,
      adHocActivityType: { name: '' }
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    allTags() {
      return this.$store.state.tagsModule.tags
    }
  },
  methods: {
    open(adHocActivityType) {

      if (adHocActivityType) {
        this.isEdit = true
        this.adHocActivityTypeCopy = { ...adHocActivityType }
        this.adHocActivityType = { ...adHocActivityType }
      }
      this.dialog = true;
    },


    async upsertAddAdHocActivityType() {

      const form = this.$refs.addAdHocActivityType as any;

      const validated = form.validate();
      if (!validated) return;

      if (this.isEdit && this.adHocActivityTypeCopy.name == this.adHocActivityType.name && this.adHocActivityTypeCopy.color == this.adHocActivityType.color) {
        this.close()
        return
      }

      this.loading = true

      if (this.isEdit) {
        const isExistsByName = await this.isExistsByName(this.adHocActivityType.name, this.adHocActivityType.id)
        if (isExistsByName) {
          this.$refs.observer.setErrors({ Name: [this.$t('GeneralTranslations.NameAlreadyExists')] });
          this.loading = false
          return
        }
        else {
          await this.$store.dispatch('updateAdHocActivityType', this.adHocActivityType)
        }
      }
      else {
        const isExistsByName = await this.isExistsByName(this.adHocActivityType.name)
        if (isExistsByName) {
          this.$refs.observer.setErrors({ Name: [this.$t('GeneralTranslations.NameAlreadyExists')] });
          this.loading = false
          return
        } else {
          await this.$store.dispatch('addAdHocActivityType', this.adHocActivityType)
        }
      }
      this.close()
    },

    async isExistsByName(name, skipId) {
      let query = firebase.firestore().collection("adHocActivitiesTypes").where("facilityId", "==", this.facility.id).where("name", "==", name)

      if (skipId) {
        query = query.where(firebase.firestore.FieldPath.documentId(), '!=', skipId)
      }

      const docs = await query.get()

      return docs.size > 0
    },

    close() {
      this.dialog = false
      this.isEdit = false
      this.loading = false
      this.adHocActivityType = { name: null }
      this.adHocActivityTypeCopy = null
    }
  }
}